import { render, staticRenderFns } from "./safOpinionBoardDetailOuterPop.vue?vue&type=template&id=2d6afc0a"
import script from "./safOpinionBoardDetailOuterPop.vue?vue&type=script&lang=js"
export * from "./safOpinionBoardDetailOuterPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6afc0a')) {
      api.createRecord('2d6afc0a', component.options)
    } else {
      api.reload('2d6afc0a', component.options)
    }
    module.hot.accept("./safOpinionBoardDetailOuterPop.vue?vue&type=template&id=2d6afc0a", function () {
      api.rerender('2d6afc0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/outer/safOpinionBoardDetailOuterPop.vue"
export default component.exports